export default "__VITE_ASSET__pR9RtFto__"